import { render } from "./ReviewCarouselSlide.vue?vue&type=template&id=ae52ab2c"
import script from "./ReviewCarouselSlide.vue?vue&type=script&lang=js"
export * from "./ReviewCarouselSlide.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__